import React, { useState } from 'react'
import Header from './Header'
import Footer from './Footer'

import {RegisterApi} from '../service/api'

const Register2 = () => {
 /* let [fname,setFname] = useState('')
  let [lname,setLname] = useState('')
  let [email,setEmail] = useState('')
  let [phone,setPhone] = useState('')
  let [password,setPassword] = useState('')
*/

  let [data,setData] = useState({
      fname:"",
      lname:"",
      email:"",
      phone:"",
      password:""
  })
  const [errors, setErrors] = useState({});
  const [msg,setMsg] = useState("")
  const [clr,setClr] = useState({color:""})

  let changeInput = (e)=>{
    //console.log(e)
    setData({
      ...data,
      [e.target.name]: e.target.value
    })
  }

  const validate =()=>{
      const newErrors = {};
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;

      // FName validation
      if (!data.fname.trim()) {
        newErrors.fname = 'FName is required';
      }

      // LName validation
      if (!data.lname.trim()) {
        newErrors.lname = 'LName is required';
      }

      // Email validation
      
      if (!data.email) {
        newErrors.email = 'Email is required';
      } else if (!emailRegex.test(data.email)) {
        newErrors.email = 'Email is not valid';
      }

      // Phone validation
      if (!data.phone.trim()) {
        newErrors.phone = 'Phone is required';
    }

    // Password validation
    if (!data.password) {
      newErrors.password = 'Password is required';
    } else if (data.password.length < 6) {
      newErrors.password = 'Password must be at least 6 characters';
    }

    setErrors(newErrors)

    // Returns true if there are no errors
    return Object.keys(newErrors).length === 0;

  }


  let register = (e)=>{
    e.preventDefault()
    if (validate()) {
      //console.log('Form submitted:', data);
      //setMsg("Register Success")
      let {fname,lname,email,phone,password} = data

      let d = new FormData()
      d.append("fname",fname)
      d.append("lname",lname)
      d.append("email",email)
      d.append("ph",phone)
      d.append("pwd",password)


      RegisterApi(d).then((res)=>{
        //data: {status: 1, message: 'Register  Successfully'}
        console.log(res.data)
        let {status,message} = res.data

        setMsg(message)
        if(status === 1){
          setClr({color:"green"})
        }else{
          setClr({color:"red"})
        }

      }).catch((erros)=>{
        console.log(erros)
      })

    }
  }


  return (
    <> 
    {/*comments */}
      <Header />
      <div className="container">
        <div className="row mt-5">
          <div className="col-md-6 mx-auto">
            <div className="card">
              <div className="card-header">
                <h1>Register2 </h1>
                <p>{JSON.stringify(data)}</p>
              </div>
              <div className="card-body">
                <form>
                  <div className="mb-3 mt-3">
                    <label htmlFor="fname" className="form-label">FirstName: </label>
                    <input type="text" className="form-control" placeholder="Enter enter FName" name="fname" onChange={changeInput} required/>
                    {errors.fname && <p className='fw-bold text-danger'>{errors.fname}</p>}
                  </div>

                  <div className="mb-3">
                    <label htmlFor="lname" className="form-label">LastName: </label>
                    <input type="text" className="form-control" placeholder="Enter enter Lname" name="lname" onChange={changeInput} />
                    {errors.lname && <p className='fw-bold text-danger'>{errors.lname}</p>}
                  </div>

                  <div className="mb-3">
                    <label htmlFor="email" className="form-label">Email: </label>
                    <input type="email" className="form-control" placeholder="Enter enter Email" name="email"  onChange={changeInput}/>
                    {errors.email && <p className='fw-bold text-danger'>{errors.email}</p>}
                  </div>

                  <div className="mb-3">
                    <label htmlFor="phone" className="form-label">Phone: </label>
                    <input type="number" className="form-control" placeholder="Enter enter Phone" name="phone"  onChange={changeInput}/>
                    {errors.phone && <p className='fw-bold text-danger'>{errors.phone}</p>}
                  </div>

                  <div className="mb-3">
                    <label htmlFor="password" className="form-label">Password: </label>
                    <input type="password" className="form-control" placeholder="Enter enter password" name="password"  onChange={changeInput}/>
                    {errors.password && <p className='fw-bold text-danger'>{errors.password}</p>}
                  </div>

                  <button type="submit" class="btn btn-primary me-2" onClick={register}>Register</button>
                  <button type="reset" class="btn btn-danger">Cancel</button>
                  <p className='mt-4 fw-bold' style={clr}>{msg}</p>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}

export default Register2
